import { Helmet } from "react-helmet";
import "./metallurgicals.scss"
import { Link } from "react-router-dom";

function Metallurgicals() {

  const scrollToTop = () => {
    window.scrollTo(0, 0)
}
  return (
    <div className="metallurgicals">
      <Helmet>
        <title>Metallurgical Supplies || Raydron, Lagos, Nigeria</title>
        <meta name="description" content="We supply various important inputs for the metaluurgical sector. These include silicon carbide graphite crucible, ferrosilicon, ferrosilicon magnesium, ferrochrome, silica sand, bentonite, ramming mass, refractory bricks, refractory cement, fire bricks, refractory mortar, castable refractory cement, arch bricks, ceramic fibre, insulation brick, fire clay, induction furnace grout, etc."/>
        <meta name="keywords" content="crucible, ferrosilicon, ferrosilicon magnesium, ferrochrome, silica sand, bentonite, ramming mass, refractory bricks, refractory cement, fire bricks, refractory mortar, castable refractory cement, arch bricks, ceramic fibre, insulation brick, fire clay, induction furnace grout, Lagos Nigeria" />
      </Helmet>
        {/* <div className="intro">
            We supply various metallurgical materials used in varying high temperature appliances such as furnaces, heat treatment systems, forges, boilers, ovens, induction heating systems etc. Our supplies include fire bricks, refractory cement, refractory mortar, ceramic fibre blanket, ferrosilicon, ferrosilicon magnesium, ramming mass, moulding sand, silicon carbide graphite crucible, premixed refractory mortar, lime, glass sand, etc.
        </div> */}
        <div className="workflow__wrapper">
          <Link  to="/products/metallurgicalsupplies/firebricks" style={{ textDecoration: 'none' }}>
          <div onClick={scrollToTop} className="workflow">
            <div className="explain">
              <h2 className="title">Fire Bricks</h2>
              <p className="text">We supply various shape and types of refractory bricks for lining melting furnaces, ovens, boilers, heat treatment furnaces, etc</p>
              
            </div>
            <div className="photo__explain">
              <img src="https://res.cloudinary.com/dobxtcf1w/image/upload/v1731153296/fire_brick_axpsp7.jpg" alt="raydron_workflow" className="workflow__img" />
              <a href="https://wa.me/+2348066816640" target="_blank" rel="noreferrer" ><button className="btnWAPM">Chat Us to Buy</button></a>
            </div>
          </div>
          </Link>
          <Link  to="/products/metallurgicalsupplies/castablerefractorycement" style={{ textDecoration: 'none' }}>
          <div onClick={scrollToTop} className="workflow">
            <div className="explain">
              <h2 className="title">Castable Refractory Cement</h2>
              <p className="text">We supply high quality castable refractory cement for lining melting furnaces, ovens, boilers, heat treatment furnaces, etc</p>

            </div>
            <div className="photo__explain">
              <img src="https://res.cloudinary.com/dobxtcf1w/image/upload/v1731153696/refractory_castable_cement_olrug4.jpg" alt="raydron_workflow" className="workflow__img" />
              <a href="https://wa.me/+2348066816640" target="_blank" rel="noreferrer" ><button className="btnWAPM">Chat Us to Buy</button></a>
            </div>
          </div>
          </Link>
          <Link  to="/products/metallurgicalsupplies/firebrickcement" style={{ textDecoration: 'none' }}>
          <div onClick={scrollToTop} className="workflow">
            <div className="explain">
              <h2 className="title">Fire Brick Mortar </h2>
              <p className="text">Fire brick mortar or refractory mortar is used for joining fire bricks together. </p>

            </div>
            <div className="photo__explain">
              <img src="https://res.cloudinary.com/dobxtcf1w/image/upload/v1731154719/refractory_mortar_qpdlwh.jpg" alt="raydron_workflow" className="workflow__img" />
              <a href="https://wa.me/+2348066816640" target="_blank" rel="noreferrer" ><button className="btnWAPM">Chat Us to Buy</button></a>
            </div>
          </div>
          </Link>
          <Link  to="/products/metallurgicalsupplies/ceramicfibre" style={{ textDecoration: 'none' }}>
          <div onClick={scrollToTop} className="workflow">
            <div className="explain">
              <h2 className="title">Ceramic Fibre </h2>
              <p className="text">We supply ceramic fibre for insulation of boilers, HVAC systems, ovens, and for many high temperature applications. </p>

            </div>
            <div className="photo__explain">
              <img src="https://res.cloudinary.com/dobxtcf1w/image/upload/v1731155167/ceramic_fibre_faltky.jpg" alt="raydron_workflow" className="workflow__img" />
              <a href="https://wa.me/+2348066816640" target="_blank" rel="noreferrer" ><button className="btnWAPM">Chat Us to Buy</button></a>
            </div>
          </div>
          </Link>
          <Link  to="/products/metallurgicalsupplies/insulationbrick" style={{ textDecoration: 'none' }}>
          <div onClick={scrollToTop} className="workflow">
            <div className="explain">
              <h2 className="title">Insulation Bricks </h2>
              <p className="text">Light Weight High Alumina Brick, also known as high-aluminium heat insulating brick, are used in building heat insulating walls in high temperature systems. </p>

            </div>
            <div className="photo__explain">
              <img src="https://res.cloudinary.com/dobxtcf1w/image/upload/v1731155791/insulating-fire-bricks_ddpl9k.jpg" alt="raydron_workflow" className="workflow__img" />
              <a href="https://wa.me/+2348066816640" target="_blank" rel="noreferrer" ><button className="btnWAPM">Chat Us to Buy</button></a>
            </div>
          </div>
          </Link>
          <Link  to="/products/metallurgicalsupplies/crucible" style={{ textDecoration: 'none' }}>
          <div onClick={scrollToTop} className="workflow">
            <div className="explain">
              <h2 className="title">Silicon Carbide Crucible</h2>
              <p className="text">Silicon carbide crucibles are generally made of carbon bonded silicon and graphite materials. Silicon carbide crucibles are suitable for smelting and melting precious metals, base metals and other metals in an induction furnace. They are used at a temperature reaching 1600 degree celsius. </p>

            </div>
            <div className="photo__explain">
              <img src="https://res.cloudinary.com/dobxtcf1w/image/upload/v1731156305/crucible_s4hk7g.jpg" alt="raydron_workflow" className="workflow__img" />
              <a href="https://wa.me/+2348066816640" target="_blank" rel="noreferrer" ><button className="btnWAPM">Chat Us to Buy</button></a>
            </div>
          </div>
          </Link>
          <Link  to="/products/metallurgicalsupplies/ferrosilicon" style={{ textDecoration: 'none' }}>
          <div onClick={scrollToTop} className="workflow">
            <div className="explain">
              <h2 className="title">FerroSilicon</h2>
              <p className="text">FerroSilicon is mainly used as a deoxidant and an alloying element in the production of steel and cast iron. FeSi increases strength, hardness, temperateness and corrosion resistance in steel. </p>

            </div>
            <div className="photo__explain">
              <img src="https://res.cloudinary.com/dobxtcf1w/image/upload/v1731156486/ferrosilicon_i8qmch.jpg" alt="raydron_workflow" className="workflow__img" />
              <a href="https://wa.me/+2348066816640" target="_blank" rel="noreferrer" ><button className="btnWAPM">Chat Us to Buy</button></a>

            </div>
          </div>
          </Link>
          <Link  to="/products/metallurgicalsupplies/ferrosiliconmagnesium" style={{ textDecoration: 'none' }}>
          <div onClick={scrollToTop} className="workflow">
            <div className="explain">
              <h2 className="title">FerroSilicon Magnesium</h2>
              <p className="text">Ferro Silicon Magnesium Alloys are master alloys of Magnesium with Iron and Silicon. They facilitate small additions of Magnesium to Iron, required to transform graphite flakes to spheroids. </p>

            </div>
            <div className="photo__explain">
              <img src="https://res.cloudinary.com/dobxtcf1w/image/upload/v1731332458/ferrosilicon_magnesium_ppnuwk.jpg" alt="raydron_workflow" className="workflow__img" />
              <a href="https://wa.me/+2348066816640" target="_blank" rel="noreferrer" ><button className="btnWAPM">Chat Us to Buy</button></a>
            </div>
          </div>
          </Link>
          <Link  to="/products/metallurgicalsupplies/rammingmass" style={{ textDecoration: 'none' }}>
          <div onClick={scrollToTop} className="workflow">
            <div className="explain">
              <h2 className="title">Ramming Mass</h2>
              <p className="text">Ramming mass is a refractory material used in induction furnaces, foundries, and other industries. High performance ramming mass is designed to minimize erosion in induction melting. </p>

            </div>
            <div className="photo__explain">
              <img src="https://res.cloudinary.com/dobxtcf1w/image/upload/v1731332650/ramming_mass_i92zhf.png" alt="raydron_workflow" className="workflow__img" />
              <a href="https://wa.me/+2348066816640" target="_blank" rel="noreferrer" ><button className="btnWAPM">Chat Us to Buy</button></a>
            </div>
          </div>
          </Link>

          <div onClick={scrollToTop} className="workflow">
            <div className="explain">
              <h2 className="title">Fire Clay</h2>
              <p className="text">Fire clay is a type of clay that is highly heat-resistant, making it suitable for applications in environments exposed to high temperatures. It’s commonly used in the production of refractory materials, such as fire bricks, kiln linings, and other heat-resistant construction materials. </p>

            </div>
            <div className="photo__explain">
              <img src="https://res.cloudinary.com/dobxtcf1w/image/upload/v1731332596/fire_clay_d1vfqb.jpg" alt="raydron_workflow" className="workflow__img" />
              <a href="https://wa.me/+2348066816640" target="_blank" rel="noreferrer" ><button className="btnWAPM">Chat Us to Buy</button></a>
            </div>
          </div>

          
          <div onClick={scrollToTop} className="workflow">
            <div className="explain">
              <h2 className="title">Induction Furnace Coil Grout</h2>
              <p className="text">Induction furnace coil grout is a specialized type of grout used to bond and insulate the coils in induction furnaces. The grout helps electrically insulate the coils from the furnace's external metal parts, ensuring that the electromagnetic field generated by the coils is focused on the material being heated or melted.</p>

            </div>
            <div className="photo__explain">
              <img src="https://res.cloudinary.com/dobxtcf1w/image/upload/v1731333117/coil_grout_sjztor.jpg" alt="raydron_workflow" className="workflow__img" />
              <a href="https://wa.me/+2348066816640" target="_blank" rel="noreferrer" ><button className="btnWAPM">Chat Us to Buy</button></a>
            </div>
          </div>

        </div>
    </div>
  )
}

export default Metallurgicals